module.exports = __webpack_public_path__ + "static/media/vedett-white.6936989d.jpg";